import { useState } from "react"

export function useFetch() {
  const [status, setStatus] = useState("idle")
  const [error, setError] = useState(null)
  const [data, setData] = useState(null)

  return {
    status,
    error,
    data,
    async request(processor) {
      setStatus("fetching")
      setError(null)
      try {
        const response = await processor()
        if (!response.ok) {
          setStatus("error")
          setError("An error occured. Kindly check your network connection.")
          return null
        } else {
          setStatus("success")
          setData(response)
          return response
        }
      } catch (err) {
        setStatus("error")
        setError(err.response?.data.message || err.message)
      }
    },
  }
}
